<div class="container rootContainer">
    <div class="main_content">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
<!--  <app-footer></app-footer>-->
</div>
